import complexSchema from "./complex.json";
import intermediateSchema from "./intermediate.json";
import simpleSchema from "./simple.json";

export type SchemaId = "simple" | "intermediate" | "complex";

export const EXAMPLE_SCHEMAS: Record<SchemaId, unknown> = {
  simple: simpleSchema,
  intermediate: intermediateSchema,
  complex: complexSchema,
};

export const SCHEMA_OPTIONS: { id: SchemaId; label: string }[] = [
  { id: "simple", label: "Simple — Beneficiary Registration" },
  { id: "intermediate", label: "Intermediate — Policy Amendment" },
  { id: "complex", label: "Complex — Claims Submission" },
];

export const DEFAULT_SCHEMA_JSON = JSON.stringify(simpleSchema, null, 2);
